import { ControlType, FormField, FormFieldInit } from "./base";

export class FormFieldSelect extends FormField {
  override controlType = ControlType.SELECT;
  options: SelectOption[];

  constructor(init: FormFieldInit<FormFieldSelect>) {
    super(init);
    this.options = init.options;
  }
}

export interface SelectOption {
  /**
   * Value attribute, will also be rendered to the user if no label is provided
   */
  value: string | Date;

  /**
   * Optional: Label that gets displayed to the user instead of the raw value property.
   */
  label?: string;

  disabled?: boolean;
}
